import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Regular Icons
import { 
    faEnvelope, 
    faFilePdf,
    faWindowRestore
} from '@fortawesome/free-regular-svg-icons'

// Solid Icons
import { 
    faMapMarkerAlt, 
    faChevronDown, 
    faChevronUp,
    faChevronCircleLeft,
    faChevronCircleRight,
    faTimes, 
    faBars,
    faPlay,
    faArrowRight,
    faBus,
    faKey,
    faWifi,
    faServer,
    faUser,
    faDatabase,
    faIdBadge,
    faAt,
    faClipboardList
} from '@fortawesome/free-solid-svg-icons'

// Brand Icons
import { 
    faGithub, 
    faLinkedin, 
    faTwitter
} from '@fortawesome/free-brands-svg-icons'

library.add(
    faEnvelope, 
    faFilePdf,
    faWindowRestore
);

library.add(
    faMapMarkerAlt, 
    faChevronDown,
    faChevronUp,
    faChevronCircleLeft,
    faChevronCircleRight,
    faTimes,
    faBars,
    faPlay,
    faArrowRight,
    faBus,
    faKey,
    faWifi,
    faServer,
    faUser,
    faDatabase,
    faIdBadge,
    faAt,
    faClipboardList
);

library.add(
    faGithub, 
    faLinkedin,
    faTwitter
);

Vue.component('font-awesome-icon', FontAwesomeIcon)